/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext, useState, useEffect } from "react";
import { Tab } from "@mui/material";
import { isEmpty } from "lodash";
import { isArrayNotEmpty } from "utils/empty-exists";
import { ContentZoneContext } from "cms/components/context";
import { EmptyContentMessage } from "cms/components/layout/empty/empty-content-message";
import { ServiceListTabContentDisplay } from "./tab-content";

const IconLinkTabsComponentDisplay = () => {

    const { component } = useContext(ContentZoneContext);
    const title = component?.title ?? "";
    const tabs = component?.tabs ?? [];
    const tabPosition = component?.tab_position ?? "top";
    const firstTabGuid = isArrayNotEmpty(tabs) ? tabs[0]?.guid : undefined;
    const hasContent = !isEmpty(tabs) || !isEmpty(tabs);
    const [selectedTab, setSelectedTab] = useState(firstTabGuid);
    const [currentTab, setCurrentTab] = useState();

    const selectTab = (event, guid) => {
        setSelectedTab(guid);
        if (isArrayNotEmpty(tabs)) {
            const tab = tabs.find((tab) => tab.guid === guid);
            setCurrentTab(tab);
        }
    };

    useEffect(() => {
        selectTab(null, firstTabGuid);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [firstTabGuid]);

    return (
        <>
            {!hasContent &&
                <EmptyContentMessage
                    hasContent={hasContent}
                    component={component}
                />
            }
            {hasContent &&
                <>
                    <div className={`icon-link-tabs ${tabPosition}`}>
                        {!!title && <h2>{title}</h2>}
                        <div className="icon-link-tabs-container">
                            <div className="icon-link-tabs-titles">
                                {isArrayNotEmpty(tabs) && tabs.map((tab, index) => {
                                    const guid = tab?.guid ?? "";
                                    const key = index + guid;
                                    const classes = currentTab?.guid === guid ? "tab active" : "tab";
                                    return (
                                        <Tab
                                            onClick={(event) => selectTab(event, guid)}
                                            key={key}
                                            value={guid}
                                            label={tab.title}
                                            className={classes}
                                        />
                                    );
                                })}
                            </div>
                            <ServiceListTabContentDisplay
                                key={selectedTab}
                                guid={selectedTab}
                                tabs={tabs}
                                tab={currentTab}
                            />
                        </div>
                    </div>
                </>
            }
        </>
    );
};

IconLinkTabsComponentDisplay.displayName = "IconLinkTabsComponentDisplay";
export { IconLinkTabsComponentDisplay };

